<template>
    <div @mouseover="enter" @mouseleave="leave" id="head">
        <a :href="link" target="_blank" @click="leave">
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.5 45.5">
<defs>
    </defs>
    <title>Stack Overflow</title>
    <circle id="StackRing" cx="22.75" cy="22.75" r="22"/>
    <polygon id="StackBox" points="27.65 34.05 14.45 34.05 14.45 25.05 12.75 25.05 12.75 35.75 12.75 35.75 13.25 35.75 29.35 35.75 29.35 35.75 29.35 35.25 29.35 25.05 27.65 25.05 27.65 34.05"/>
    <rect class="StackItem" x="22.2" y="25.13" width="2.21" height="10.04" transform="translate(-11.07 48.4) rotate(-84.86)"/>
    <rect class="StackItem" x="15.85" y="30.05" width="10.1" height="2.2"/>
    <polygon class="StackItem" points="28.15 21.95 19.45 16.75 18.35 18.65 27.05 23.85 28.15 21.95"/>
    <polygon class="StackItem" points="26.85 24.45 17.15 21.75 16.55 23.85 26.25 26.55 26.85 24.45"/>
    <polygon class="StackItem" points="31.05 9.75 28.95 10.15 30.65 20.25 32.75 19.85 31.05 9.75"/>
    <polygon class="StackItem" points="22.85 13.15 28.55 21.65 30.35 20.45 24.65 11.95 22.85 13.15"/>
</svg>


        </a>
    </div>
</template>

<script>
// work on background transitions to make the hover less stark
// --> https://stackoverflow.com/questions/20012240/using-css-to-transition-the-fill-property-of-an-svg-path-on-hover
export default {
    props: {
        link: String,
        darkMode: Boolean
    },
    methods: {
        enter: function () {
            document.getElementById("StackRing").style.stroke = "#545454";
            document.getElementById("StackRing").style.fill = "#FFFFFF";
            document.getElementById("StackBox").style.fill = "#BCBBBB";
            document.getElementsByClassName("StackItem").forEach(element => {
                element.style.fill = "#F48024";
            });
        },
        leave: function () {
            document.getElementById("StackRing").style.stroke = this.darkMode ? "#000000": "#FFFFFF";
            document.getElementById("StackRing").style.fill = "none";
            document.getElementById("StackBox").style.fill = this.darkMode ? "#000000": "#FFFFFF";
            document.getElementsByClassName("StackItem").forEach(element => {
                element.style.fill = this.darkMode ? "#000000": "#FFFFFF";
            });
        }
    },
    mounted() {
        // set light mode attributes, icon dark by default
        if (!this.darkMode) {
            document.getElementById("StackRing").style.stroke = "#FFFFFF";
            document.getElementById("StackBox").style.fill = "#FFFFFF";
            document.getElementsByClassName("StackItem").forEach(element => {
                element.style.fill = "#FFFFFF";
            });
        }
    }
}
</script>

<style scoped>
#head {
    height: 45px;
    width: 45px;
    /* margin-right: 10px; */
    /* margin-bottom: 10px; */
}
#StackRing {
    fill: none;
    stroke: #000;
    stroke-width: 1.5px;
}
.StackItem, #Stackbox{
    fill-rule:  evenodd;
}
.StackItem {
    transition: fill .4s linear;
}
svg {
    width: 45px;
    position: absolute;
}
</style>